import { Button } from '@/design-system';

import { inspectionsCopy } from '../copy';

export interface AttentionLineProps {
    /** De tellers van de filterpillen; ontbreken zolang ze laden. */
    counts: Record<string, number> | undefined;
    onStatusChange: (key: string) => void;
}

/**
 * De regel onder de kop van Keuringen: *Wacht op jou: 2 nieuw · 1 rapport na te
 * lezen*. Elk deel is een knop die het statusfilter op die status zet, zodat
 * elk getal meteen naar het werk erachter leidt. Een deel zonder werk valt weg;
 * is er niets, dan is er geen regel.
 *
 * De tellers zijn die van de pillen *Nieuw* en *Concept rapport*: ze volgen de
 * zoekterm en de dienst, net als de pillen zelf.
 */
export function AttentionLine({ counts, onStatusChange }: AttentionLineProps) {
    const parts = [
        { key: 'nieuw', count: counts?.nieuw ?? 0, label: inspectionsCopy.attentionNew },
        { key: 'concept', count: counts?.concept ?? 0, label: inspectionsCopy.attentionDraft },
    ].filter((part) => part.count > 0);

    if (parts.length === 0) {
        return null;
    }

    return (
        <div
            role="group"
            aria-label={inspectionsCopy.attentionLabel}
            className="flex shrink-0 flex-wrap items-center gap-x-2 border-b border-[var(--border-default)] bg-[var(--surface-card)] px-6 py-1 text-[13px] text-[var(--text-secondary)]"
        >
            {/* De spaties staan ook in de tekst zelf, niet alleen in de `gap`: zo
                leest een schermlezer en een kopie "Wacht op jou: 2 nieuw · …". */}
            <span>{`${inspectionsCopy.attentionLead} `}</span>
            {parts.map((part, index) => (
                <span key={part.key} className="inline-flex items-center gap-x-2">
                    {index > 0 ? <span aria-hidden="true">{' · '}</span> : null}
                    <Button
                        variant="ghost"
                        className="min-h-[40px]"
                        onClick={() => onStatusChange(part.key)}
                    >
                        {part.label(part.count)}
                    </Button>
                </span>
            ))}
        </div>
    );
}
